import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import { useState } from 'react';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const URIField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.uri && touched.uri}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>URI</FormLabel>
                <Field
                    name="uri"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            placeholder="Enter registrar URI"
                            className="!h-[30px] rounded-[5px] pl-2"
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Enter the SIP URI of the registrar server (often the SIP domain). REGISTER requests will be sent to this address. Format can be a domain or IP, with an optional port.
Example: sip.provider.com or 1.2.3.4:5060"
                        ariaLabel="registrar-uri-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError error={errors?.uri} touched={touched?.uri} />
        </FormControl>
    );
};

export default URIField;
